export default __webpack_public_path__ + "static/media/birla-mandir.01a306b3.jpg";